<template>
  <b-modal
    modal-class="component-modal-product"
    id="unitItemModal"
    ref="unitItemModal"
    size="lg"
    :title="modalTitle"
    no-close-on-backdrop
    @close="close"
  >
    <b-form id="unitTable" @submit.prevent="saveUnit">
      <b-form-group label-cols="3" label="รหัสหน่วย:" label-align="right">
        <b-form-input
          class="required"
          id="unitCode"
          v-model="unitItem.unitCode"
          :class="{ 'is-invalid': $v.unitItem.unitCode.$error }"
          maxlength="10"
          placeholder="กรอกรหัสของหน่วยสินค้า"
        ></b-form-input>
        <template v-slot:description> </template>
      </b-form-group>

      <b-form-group label-cols="3" label="ชื่อหน่วย:" label-align="right">
        <b-form-input
          class="required"
          id="unitNameTh"
          v-model="unitItem.unitNameTh"
          :class="{ 'is-invalid': $v.unitItem.unitNameTh.$error }"
          maxlength="50"
          placeholder="กรอกชื่อหน่วยภาษาไทย"
        ></b-form-input>
        <template v-slot:description> </template>
      </b-form-group>

      <b-form-group label-cols="3" label="ชื่อหน่วย (Eng):" label-align="right">
        <b-form-input
          id="unitNameEn"
          maxlength="50"
          v-model="unitItem.unitNameEn"
          placeholder="กรอกชื่อหน่วยภาษาอังกฤษ"
        ></b-form-input>
        <template v-slot:description> </template>
      </b-form-group>
    </b-form>

    <template v-slot:modal-footer>
      <b-button v-if="!isNewUnit" variant="danger" @click="deleteUnit(unitItem)"
        >ลบรายการ</b-button
      >
      <b-button type="submit" form="unitTable" variant="primary">
        {{ isNewUnit ? "สร้างรายการ" : "แก้ไขรายการ" }}
      </b-button>
    </template>
    <Dialog ref="Dialog"></Dialog>
    <Loading v-if="isLoading"></Loading>
  </b-modal>
</template>

<script>
import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import "@/theme/modal/ProductAndStock/Product.scss";
import { maxLength, required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "UnitCreateModal",
  components: {
    Dialog,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      modalTitle: "รายการหน่วยสินค้า",
      isNewUnit: true,
      unitItem: {
        unitId: "",
        unitCode: "",
        unitNameTh: "",
        unitNameEn: "",
      },
    };
  },
  validations: {
    unitItem: {
      unitCode: {
        required,
        maxLength: maxLength(10),
      },
      unitNameTh: {
        required,
        maxLength: maxLength(50),
      },
      unitNameEn: {
        maxLength: maxLength(50),
      },
    },
  },
  computed: {
    ...mapGetters({
      getUnitList: "moduleUnitMaster/getUnitList",
    }),
  },
  methods: {
    ...mapActions({
      fetchUnitList: "moduleUnitMaster/fetchUnitList",
    }),
    show(data) {
      if (data) {
        this.isNewUnit = false;
        this.unitItem = Object.assign({}, data);
      } else {
        this.isNewUnit = true;
        this.setDefaultValue();
      }
      this.$bvModal.show("unitItemModal");
    },
    close() {
      this.$v.$reset();
      this.setDefaultValue();
      this.isNewUnit = true;
      this.$bvModal.hide("unitItemModal");
    },
    reloadUnitList() {
      this.fetchUnitList({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
      });
    },
    setDefaultValue() {
      this.unitItem = Object.assign(
        {},
        {
          unitCode: "",
          unitNameTh: "",
          unitNameEn: "",
        }
      );
    },
    saveUnit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.isLoading = true;

      const adjustUnitItem = {
        code: this.unitItem.unitCode,
        description: this.unitItem.unitNameTh,
        description2: this.unitItem.unitNameEn,
      };

      if (this.isNewUnit) {
        this.$store
          .dispatch("moduleUnitMaster/createUnitItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            adjustUnitItem,
          })
          .then(res => {
            if (res.status == 201) {
              this.reloadUnitList();
              this.close();
              this.$parent.showDialogToast(
                "success",
                "เพิ่มรายการหน่วยสินค้าสำเร็จ"
              );
            }

            this.close();
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "เพิ่มรายการหน่วยสินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$store
          .dispatch("moduleUnitMaster/updateUnitItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            adjustUnitItem,
            id: this.unitItem.unitId,
          })
          .then(res => {
            if (res.status == 200) {
              this.reloadUnitList();
              this.close();
              this.$parent.showDialogToast(
                "success",
                "แก้ไขรายการหน่วยสินค้าสำเร็จ"
              );
            }
            this.close();
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "แก้ไขรายการหน่วยสินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    deleteUnit(eventData) {
      this.$refs.Dialog.showAlertConfirm(
        "ลบหน่วยสินค้านี้ ?",
        "คุณต้องการลบหน่วยสินค้านี้ใช่หรือไม่"
      ).then(result => {
        if (!result.value) return;
        this.isLoading = true;

        this.$store
          .dispatch("moduleUnitMaster/deleteUnitItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            id: this.unitItem.unitId,
          })
          .then(res => {
            if (res.status == 200) {
              this.reloadUnitList();
              this.close();
              this.$parent.showDialogToast(
                "success",
                "ลบรายการหน่วยสินค้าสำเร็จ"
              );
            }
            this.close();
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "ลบรายการหน่วยสินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
  },
};
</script>
